import { AppRoutes } from '@constants';

export const isSamePage = (locationPathname: string, appRoute: string) =>
  locationPathname.includes(appRoute);

export const candidateDetailsPath = (
  candidateId: string,
  listSearch: string,
) => {
  const view = listSearch.replace(/^\?/, '');

  return `/${AppRoutes.CANDIDATES}/${candidateId}${view ? `?v=${encodeURIComponent(view)}` : ''}`;
};

export const candidatesListPath = (detailsSearch: string) => {
  const view = new URLSearchParams(detailsSearch).get('v');

  return `/${AppRoutes.CANDIDATES}${view ? `?${view}` : ''}`;
};
